import angular from 'angular';
import signin from './signin.directive';
import countdownClock from '../countdownclock/countdownclock.directive';
import './signin.css';

export default angular.module('signin', [])
.directive('vlsignin', signin)
.directive('vlcountdownclock', countdownClock).name;
